import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette }: Theme) => ({
  label: {
    marginBottom: 5,
    color: custom.grey[2],
    fontSize: 13,
    transform: 'scale(0.92)',
  },
  titleWrapper: {
    display: 'flex',
  },
  tooltip: {
    fontSize: 13,
    marginLeft: 5,
  },
  item: {
    marginRight: 10,
    marginBottom: 10,
  },
  selectBoxRoot: {
    padding: 0,
    border: 0,
    margin: 0,
    fontSize: 16,
  },

  filterGroup: {
    padding: '15px 0',
    display: 'flex',
    justifyContent: 'space-between',
    '&:not(:first-child)': {
      borderTop: `1px solid ${custom.grey[1]}`,
    },
  },
  formGroup: {
    borderBottom: `1px solid ${custom.grey[1]}`,
  },
  adjust: {
    color: custom.grey[2],
    fontWeight: 500,
    cursor: 'pointer',
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
  },
}));
